var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authsucc"},[_vm._m(0),_c('div',{staticClass:"footer"},[_c('van-button',{attrs:{"type":"info"},on:{"click":function($event){return _vm.back()}}},[_vm._v(" 重新识别 ")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('img',{attrs:{"src":require("../../../assets/images/account/auth_fail.png")}}),_c('div',[_c('span',[_vm._v("实名认证失败! 请重新尝试")])])])
}]

export { render, staticRenderFns }